import React, { useState, useEffect } from 'react';
import { Navbar } from './Navbar';
import './IllusionTest.css';
import { BrainTransition } from './BrainTransition';

// ═══════════════════════════════════════════════════════════════
// SIMPLE FEEDBACK PHRASES
// ═══════════════════════════════════════════════════════════════

const FEEDBACK_PHRASES = [
  "Got it!",
  "Nice one!",
  "Noted!",
  "Great pick!",
  "Interesting!",
  "Captured!",
];

export const IllusionTest = ({
  illusion,
  onAnswer,
  questionNumber,
  totalQuestions,
  user,
  onSignInClick
}) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [feedbackText, setFeedbackText] = useState('');
  const [showTransition, setShowTransition] = useState(false);
  const [selectedDominance, setSelectedDominance] = useState(null);

  // Reset selected option when illusion changes (new question)
  useEffect(() => {
    if (illusion) {
      setSelectedOption('');
      setFeedbackText('');
      setShowTransition(false);
      setSelectedDominance(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [illusion?.id]);

  const handleOptionSelect = (optionId) => {
    setSelectedOption(optionId);

    // Pick random simple phrase
    const randomPhrase = FEEDBACK_PHRASES[Math.floor(Math.random() * FEEDBACK_PHRASES.length)];
    setFeedbackText(randomPhrase);

    const selectedChoice = illusion.answer_options.find(opt => opt.id === optionId);

    if (selectedChoice) {
      // Store the dominance type for the transition animation
      setSelectedDominance(selectedChoice.brain_dominance_type);

      // Quick transition - show immediately, then move to next question
      setTimeout(() => {
        setShowTransition(true);

        // Fast transition - 1.2 seconds total
        setTimeout(() => {
          onAnswer(optionId, selectedChoice.brain_dominance_type);
        }, 1200);
      }, 200);
    }
  };

  return (
    <div className="illusion-test base-background">
      <Navbar currentUser={user} onSignInClick={onSignInClick} />
      <div className="progress-section">
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${(questionNumber / totalQuestions) * 100}%` }}
          />
        </div>
      </div>

      {showTransition ? (
        <div className="transition-wrapper" style={{ flex: 1, width: '100%', height: '100%', minHeight: '400px', display: 'flex', flexDirection: 'column' }}>
          <BrainTransition
            phrase={feedbackText}
            dominanceType={selectedDominance}
            questionNumber={questionNumber}
            totalQuestions={totalQuestions}
          />
        </div>
      ) : !illusion ? (
        <div className="transition-wrapper" style={{ flex: 1, width: '100%', height: '100%', minHeight: '400px', display: 'flex', flexDirection: 'column' }}>
          <BrainTransition phrase="Loading..." dominanceType={null} questionNumber={0} totalQuestions={totalQuestions} />
        </div>
      ) : (
        <div className="illusion-content" key={illusion.id}>
          <h2 className="illusion-title" data-text={illusion.question}>{illusion.question}</h2>

          <div className="illusion-image-container">
            <img
              src={illusion.image_url}
              alt={illusion.title}
              className="illusion-image"
            />
          </div>

          <div className="question-section">
            <div className="options-grid">
              {illusion.answer_options.map((option) => (
                <button
                  key={option.id}
                  className={`option-card ${selectedOption === option.id ? 'energized' : ''}`}
                  onClick={() => handleOptionSelect(option.id)}
                  disabled={selectedOption !== ''}
                >
                  <span className="option-text">{option.text}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};